const ACCORDION_SELECTOR = '[data-component="wc-tabs-accordion"]';
const ITEM_SELECTOR = '[data-tab-item]';
const PANEL_SELECTOR = '[data-tab-panel]';
const TOGGLE_SELECTOR = '[data-tab-toggle]';

const setMaxHeight = (panel, height) => {
    panel.style.maxHeight = `${Math.max(height, 0)}px`;
};

const openPanel = (item, panel) => {
    panel.hidden = false;
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    panel.style.maxHeight = '0px';
    requestAnimationFrame(() => {
        item.classList.add('is-open');
        setMaxHeight(panel, panel.scrollHeight);
    });
};

const closePanel = (item, panel) => {
    panel.setAttribute('aria-hidden', 'true');
    const currentHeight = panel.scrollHeight;
    setMaxHeight(panel, currentHeight);
    requestAnimationFrame(() => {
        item.classList.remove('is-open');
        panel.style.maxHeight = '0px';
    });
};

const toggleItem = (item, panel, toggle, expand) => {
    toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
    if (expand) {
        openPanel(item, panel);
    } else {
        closePanel(item, panel);
    }
};

const initItem = (item) => {
    const panel = item.querySelector(PANEL_SELECTOR);
    const toggle = item.querySelector(TOGGLE_SELECTOR);
    if (!panel || !toggle) return;

    panel.hidden = false;
    panel.removeAttribute('hidden');
    panel.style.maxHeight = '0px';
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');

    toggle.addEventListener('click', () => {
        const expanded = item.classList.contains('is-open');
        toggleItem(item, panel, toggle, !expanded);
    });

    const refreshHeight = () => {
        if (!item.classList.contains('is-open')) return;
        setMaxHeight(panel, panel.scrollHeight);
    };

    if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(refreshHeight);
        observer.observe(panel);
    } else {
        window.addEventListener('resize', refreshHeight);
    }
};

const initWcTabsAccordion = () => {
    document.querySelectorAll(ACCORDION_SELECTOR).forEach((accordion) => {
        accordion.querySelectorAll(ITEM_SELECTOR).forEach((item) => initItem(item));
    });
};

document.addEventListener('DOMContentLoaded', initWcTabsAccordion);
